import UserCard from "./user-card";
import { Grid } from "@mui/material";
import { User } from "@domain/model/User";
import { useResponsiveGrid } from "@hooks/useResponsiveGrid";
import { DomainPage } from "@movicoders/domain/lib/Entities/DomainPage";
import { NoRecordsFound } from "@components/no-records-found/no-records-found";

interface ICardsDisplay {
  dataPaginated: DomainPage<User>;
  handleOpenUpsertDialog: (id: string) => void;
  handleOpenToggleActiveStatusDialog: (user: User) => void;
}

export const UsersCardsDisplay = (props: ICardsDisplay) => {
  const { handleMediaQuery } = useResponsiveGrid();
  const columns = handleMediaQuery(4, 3, 2, 2);
  const CARD_GRID_MD = Math.round(12 / columns);
  const CARD_GRID_SM = Math.round(8 / columns);

  return props.dataPaginated?.content?.length && props.dataPaginated?.content?.length > 0 ? (
    <>
      {props.dataPaginated?.content?.map((user: User, index: number) => (
        <Grid item xs={12} sm={CARD_GRID_SM} md={CARD_GRID_MD} lg={CARD_GRID_MD} key={`grid-card-${user.id}`}>
          <UserCard
            user={user}
            handleEdit={props.handleOpenUpsertDialog}
            handleActive={props.handleOpenToggleActiveStatusDialog}
          />
        </Grid>
      ))}
    </>
  ) : (
    <NoRecordsFound />
  );
};
